export default "__VITE_ASSET__BGpGx9l5__"